import { APIClient } from '@frontend/api-utils';
import { ReportApplicationTemplateResponse } from '@frontend/report/types';

export class ReportTemplateClient extends APIClient {
    public static readonly endpoint = '/report-api/v1';

    public static async fetchReportApplicationTemplates(): Promise<ReportApplicationTemplateResponse> {
        const res = await this.fetch(`${this.endpoint}/report-application-templates`);
        return await this.handleResponse<ReportApplicationTemplateResponse>(res);
    }
}
